import { Button, Select, Table } from 'antd'
import React, { useEffect, useState } from 'react'
import { Link, useLoaderData, useNavigate } from 'react-router-dom'
import Pagination from '../../globalComponents/Pagination'
import EventEmitter from '../../utils/eventEmitter'
import Axios from '../utils/axios'



const columns = [
  {
    title: 'Code',
    dataIndex: 'code',
    key: 'code',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Type',
    dataIndex: 'type',
    key: 'type',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Action',
    key: 'operation',
    fixed: 'right',
    width: 100,
    className: 'whitespace-nowrap font-medium text-dark-600 dark:text-white',
    render: (_, record) => (
      <Link className='h-full w-full' to={'/accounting/journals/'+ record.seo}>
        SETUP
      </Link>
    )
  }
]



const Journals = () => {
  const loader = useLoaderData();
  const navigate = useNavigate();
  const [items, setItems] = useState(loader);
  const [paginations, setPaginations] = useState({pageSize: 100, page: 1});


  
  const onRow = (record, rowIndex) => {
    return {
      onClick: () => navigate('/accounting/journals/'+record.seo)
    };
  }

  async function fetchUserList(pagination_) {

    return Axios(`journals/search?pagination=${JSON.stringify(pagination_)}`)
      .then((response) => response.data)
      .then((res) => {
        setItems(res);
      });
  }
 
  useEffect(() => {
    const offset = (paginations.page - 1) * paginations.pageSize;
    let pagination_ = {offset, pageSize: paginations.pageSize};
    // let filters = {search: {by: searchBy, values: search, filters: selectedFilters}};
    fetchUserList(pagination_);
  },[paginations])

  return (
    <div>
      <div className='flex justify-between mx-4'>
        <h3 className='font-bold'>Journals</h3>
        <div className=' bg-white dark:bg-gray-900'>
          {/* <Input addonBefore={<MdFilterAlt />}  defaultValue="mysite" /> */}

          <Select
            mode='multiple'
            size={'middle'}
            placeholder='Filter'
            className='w-96'
          />
        </div>
      </div>
      <div className='columns-2 mx-4 my-2'>
        <div className='column'>
          <Button className='' size={'sm'}>
            <Link to={'/accounting/journals/new'} className='w-full'>
              Create
            </Link>
          </Button>
        </div>
        <div className='dark:bg-gray-900 column'>
          <div className='flex justify-end'>
            <Pagination paginations={paginations} setPaginations={setPaginations} total={items.totalRows} />
          </div>
        </div>
      </div>
      <Table
        onRow={onRow}
        rowClassName={'hover:cursor-pointer'}
        dataSource={items.all}
        columns={columns}
        scroll={{ x: 1500 }}
        pagination={false}
        rowKey='code'
      />
    </div>
  )
}

export default Journals;
